import { render } from "./GanttGrid.vue?vue&type=template&id=28502af8"
import script from "./GanttGrid.vue?vue&type=script&lang=ts"
export * from "./GanttGrid.vue?vue&type=script&lang=ts"
script.render = render

export default script